import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, mergeMap, catchError, of } from 'rxjs';
import * as PermissionActions from './permission.actions';
import { isPlatformBrowser } from '@angular/common';
import { getAuthItem } from '../auth/auth-session';

@Injectable()
export class PermissionEffects {
  actions$ = inject(Actions)
  platformId = inject(PLATFORM_ID);
  http = inject(HttpClient)

  loadUserMenus$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PermissionActions.loadUserMenus),
      mergeMap(() => {
        // Fetch token from local storage
        let token = '';
        if (isPlatformBrowser(this.platformId)) {
          token = getAuthItem('token') || '';
        }
        const headers = new HttpHeaders({ 'x-access-token': `Bearer ${token}` });
        const apiUrl = 'mock-data.json';

        return this.http.get(apiUrl, { headers }).pipe(
          map((response: any) => {
            // Extract data based on roles (e.g., Approver, Super Admin)
            const approverData = response.find((obj: any) => obj.role === 'Approver');
            const menus = approverData ? approverData.userMenus : [];
            return PermissionActions.loadUserMenusSuccess({ menus });
          }),
          catchError((error) => {
            console.error('Error loading user menus:', error);
            return of(PermissionActions.loadUserMenusFailure({ error }));
          })
        );
      })
    )
  );
}
